import { routerApp, analyticsUrl, enableOnPremise } from '../../app.module';
import { httpRequestGenerator } from '../../services/utilities';

routerApp.factory('FleetPerformanceService', ['$http', function($http) {
    var requestFunc = httpRequestGenerator(enableOnPremise, $http);
    
    return {
        getAggregateMetrics: function(username, reportFrom = null, vessel_ids = null) {
            return requestFunc({
                url: analyticsUrl + 'fleetPerformanceAPI/aggregateMetrics',
                method: 'POST',
                data: {
                    username: username,
                    reportFrom: reportFrom,
                    vesselIds: vessel_ids
                }
            });
        },
        getMetricData: function(username, metricKey, reportFrom = null, vessel_ids = null) {
            return requestFunc({
                url: analyticsUrl + 'fleetPerformanceAPI/getMetric',
                method: 'POST',
                data: {
                    username: username,
                    metric: metricKey,
                    reportFrom: reportFrom,
                    vesselIds: vessel_ids
                }
            });
        }
    }
}]);